import React from "react";

export default function VenmoIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.6972 1.16467C20.4216 2.32031 20.7482 3.51063 20.7482 5.01425C20.7482 9.80999 16.51 16.04 13.0702 20.4147H5.21348L2.0625 2.21468L8.9419 1.58378L10.6078 14.5342C12.1645 12.0846 14.0854 8.23507 14.0854 5.61048C14.0854 4.17387 13.8307 3.19536 13.4324 2.38966L19.6972 1.16467Z" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
}
